export default {
  title: 'Страница потерялась',
  subtitle: `Страницы, которую вы ищете, нет в системе.
    Возможно, была какая-то ошибка в адресе.`,
  text: 'Попробуйте еще раз ввести адрес страницы или найдите ее через главную',
};
